import { render, staticRenderFns } from "./IconPicker.vue?vue&type=template&id=cbd1ce84&scoped=true"
import script from "./IconPicker.vue?vue&type=script&lang=js"
export * from "./IconPicker.vue?vue&type=script&lang=js"
import style0 from "./IconPicker.vue?vue&type=style&index=0&id=cbd1ce84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd1ce84",
  null
  
)

export default component.exports